import { Component, Input } from '@angular/core'
import { CartItemListComponent } from '@spartacus/cart/base/components'

@Component({
    selector: 'app-custom-cart-item-list-stock',
    templateUrl: './custom-cart-item-list-stock.component.html',
    styleUrls: ['./custom-cart-item-list-stock.component.scss'],
    standalone: false
})
export class CustomCartItemListStockComponent extends CartItemListComponent {
  @Input() showStockStatus = true
}
